import React, { useState } from 'react';
import { Layout } from './components/Layout';
import { CountrySelector } from './components/CountrySelector';
import { LandmarkSelector } from './components/LandmarkSelector';
import { LocationExplorer } from './components/LocationExplorer';
import { tourData } from './data/tourData';
export function App() {
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [selectedLandmark, setSelectedLandmark] = useState(null);
  const [currentLocationIndex, setCurrentLocationIndex] = useState(0);
  const handleCountrySelect = country => {
    setSelectedCountry(country);
    setSelectedLandmark(null);
  };
  const handleLandmarkSelect = landmark => {
    setSelectedLandmark(landmark);
    setCurrentLocationIndex(0);
  };
  const handleBackToCountries = () => {
    setSelectedCountry(null);
    setSelectedLandmark(null);
  };
  const handleBackToLandmarks = () => {
    setSelectedLandmark(null);
  };
  return <Layout data-id="element-0">
      {!selectedCountry ? <CountrySelector countries={tourData.countries} onSelectCountry={handleCountrySelect} data-id="element-1" /> : !selectedLandmark ? <LandmarkSelector country={selectedCountry} onSelectLandmark={handleLandmarkSelect} onBack={handleBackToCountries} data-id="element-2" /> : <LocationExplorer landmark={selectedLandmark} currentLocationIndex={currentLocationIndex} setCurrentLocationIndex={setCurrentLocationIndex} onBack={handleBackToLandmarks} data-id="element-3" />}
    </Layout>;
}